import { useState } from 'react';
import { TLandmarkContent } from '../domain/LandmarksDestination.domain';
import * as S from './LandmarkDestinationPage.style';
import { Container } from '@/common/ui/containers/Container';
import { ImagesWidget } from '@/common/ui/images/ImagesWidget/ImagesWidget';
import { useMedia } from '@/common/service/hooks/useMedia';
import ReactMarkdown from 'react-markdown';

export const LandmarkContent = ({ landmark, images }: TLandmarkContent) => {
    const isDesktop = useMedia('(min-width: 992px)');
    const [readMore, setReadMore] = useState(false);
    const { content, what_to_know, when_to_go, how_much_cost, how_to_get, video } = landmark.data;

    return (
        <Container>
            <S.Data>
                <S.DescriptionTitle>{`${landmark.name} Visitors Guide`}</S.DescriptionTitle>
                <ReactMarkdown linkTarget="_blank">{content}</ReactMarkdown>

                {!isDesktop && !readMore ? (
                    <S.ReadMore onClick={() => setReadMore(true)} isActive={readMore}>
                        Read more
                        <S.Arrow isActive={readMore} />
                    </S.ReadMore>
                ) : (
                    <>
                        {when_to_go && (
                            <S.Paragraph>
                                <S.DescriptionTitle>When to go?</S.DescriptionTitle>
                                <ReactMarkdown linkTarget="_blank">{when_to_go}</ReactMarkdown>
                            </S.Paragraph>
                        )}
                        {how_much_cost && (
                            <S.Paragraph>
                                <S.DescriptionTitle>How Much Does it Cost?</S.DescriptionTitle>
                                <ReactMarkdown linkTarget="_blank">{how_much_cost}</ReactMarkdown>
                            </S.Paragraph>
                        )}
                        {how_to_get && (
                            <S.Paragraph>
                                <S.DescriptionTitle>
                                    How to get There (Directions and Where to Park)?
                                </S.DescriptionTitle>
                                <ReactMarkdown linkTarget="_blank">{how_to_get}</ReactMarkdown>
                            </S.Paragraph>
                        )}
                        {what_to_know && (
                            <S.Paragraph>
                                <S.DescriptionTitle>What to Know Before You go?</S.DescriptionTitle>
                                <ReactMarkdown linkTarget="_blank">{what_to_know}</ReactMarkdown>
                            </S.Paragraph>
                        )}
                    </>
                )}
            </S.Data>
            <ImagesWidget images={images} path="landmark_photo" video={video} />
        </Container>
    );
};
